import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-our-services',
  templateUrl: './our-services.component.html',
  styleUrls: ['./our-services.component.scss'],
})
export class OurServicesComponent implements OnInit {
  public Services = [
    {
      id: '1.',
      title: 'RESPUESTA ANTE EMERGENCIAS',
      desc:
        // tslint:disable-next-line:max-line-length
        'Damos respuesta ante emergencias con materiales peligrosos las 24 horas, los 365 días del año. Para ello contamos con un teléfono de emergencias 0810-44-429682. Estamos preparados para llegar en forma terrestre o aérea en todo el territorio nacional o países limítrofes.',
      img: 'assets/services/1.jpg',
      items: [
        'Respuesta ante emergencias en el transporte de productos químicos, plantas de procesos y/o depósitos.',
      ],
    },
    {
      id: '2.',
      title:
        'CAPACITACIONES IN COMPANY PRESENCIALES Y A DISTANCIA',
      desc:
        // tslint:disable-next-line:max-line-length
        'Ofrecemos capacitación especializada con orientación a Brigadas de Emergencias, Servicios de Higiene y Seguridad, Servicios de Medicina Ocupacional, Bomberos Oficiales y Voluntarios, Sistemas de Atención Médica Prehospitalaria e Intrahospitalaria, Defensa Civil y Fuerzas de Seguridad. Las capacitaciones son diseñadas acorde a las necesidades del solicitante. Contamos con la certificación en gestión de la Calidad ISO 9001:2015. Solicitar oferta académica anual.',
      img: 'assets/services/2.jpg',
      items: [
        'Respuesta ante emergencias en el transporte de productos químicos, plantas de procesos y/o depósitos.',
        'Cursos diseñados a medida.',
        'Cursos abiertos.',
        'Solicitar oferta académica anual.',
      ],
    },
    {
      id: '3.',
      title: 'ASESORAMIENTO Y GESTIÓN DEL RIESGO QUÍMICO',
      img: 'assets/services/3.jpg',
      items: [
        'Asesoramiento legal y técnico en toxicología laboral y ambiental.',
        'Asesoramiento y desarrollo de planes de gestión de Seguridad e Higiene y Medio Ambiente',
        'Acompañamiento de cianuro y otros productos.',
        'Relevamiento de riesgos en rutas.',
        'Elaboración de programas de seguridad.',
        'Sistemas de autoprotección. Planes de emergencias.',
        'Seguridad en la descarga de puertos.',
        'Elaboración de Fichas de Datos de Seguridad FDS y Fichas de Intervención.',
      ],
    },
    {
      id: '4.',
      title: 'TRABAJOS DE ALTO RIESGO QUÍMICO',
      desc: '',
      img: 'assets/services/4.jpg',
      items: [
        'Trabajos en espacios confinados.',
        'Manejo de materiales peligrosos en desuso. Gestión de residuos.',
        'Reacondicionamiento de zonas afectadas por emergencias.',
      ],
    },
  ];

  constructor() {}

  ngOnInit() {}
}
